module.exports = __webpack_public_path__ + "./img/new-feature.svg";